var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.1,1.8h15c0.3,0,0.6-0.2,0.8-0.4s0.2-0.6,0-0.9S20.4,0,20.1,0h-15C4.4,0,3.7,0.3,3.2,0.8 C2.7,1.3,2.4,2,2.4,2.7v12.5c0,0.7,0.3,1.4,0.8,1.9c0.5,0.5,1.2,0.8,1.9,0.8h3.5c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9H5.1 c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6v-10c0.3,0.1,0.6,0.2,0.9,0.2h14.1v10.7h-3.6c-0.3,0-0.6,0.2-0.8,0.4 c-0.2,0.3-0.2,0.6,0,0.9c0.2,0.3,0.5,0.4,0.8,0.4h4.5c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6V4.5c0-0.2-0.1-0.5-0.3-0.6 c-0.2-0.2-0.4-0.3-0.6-0.3h-15c-0.3,0-0.6-0.2-0.8-0.4c-0.2-0.3-0.2-0.6,0-0.9C4.5,2,4.7,1.8,5.1,1.8z M13,12.6l1.2,1.2 C14.3,14,14.7,14,15,14c0.3-0.1,0.5-0.3,0.6-0.6c0.1-0.3,0-0.6-0.2-0.9l-2.7-2.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.5-0.1-0.7,0 c-0.1,0-0.2,0.1-0.3,0.2l-2.7,2.7c-0.2,0.2-0.3,0.6-0.2,0.9c0.1,0.3,0.3,0.5,0.6,0.6c0.3,0.1,0.6,0,0.9-0.2l1.2-1.2v9.5H8.6 c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1h7c0.5,0,1-0.4,1-1c0-0.5-0.4-1-1-1H13V12.6z M17.1,10.1c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1 c0.5,0,1-0.4,1-1C18.1,10.5,17.6,10.1,17.1,10.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/icon-withdraw.724f505ab3d31eeeb997660961868518.svg";
export { ForwardRef as ReactComponent };